module.exports = __webpack_public_path__ + "img/brackets_left_layout_icon.cc38b93b.svg";